import { collection, query, getDocs, getDoc, doc } from 'firebase/firestore';
import { db } from '../firebase';

export const getForumsWithMessageCounts = async () => {
  try {
    const forumQuery = query(collection(db, 'forums'));
    const forumSnapshot = await getDocs(forumQuery);
    
    const forumsWithCounts = await Promise.all(forumSnapshot.docs.map(async (forumDoc) => {
      const forumData = forumDoc.data();
      const messagesQuery = query(collection(db, 'forums', forumDoc.id, 'messages'));
      const messagesSnapshot = await getDocs(messagesQuery);
      
      // Get unique users from messages
      const uniqueUsers = new Set();
      messagesSnapshot.docs.forEach(messageDoc => {
        const messageData = messageDoc.data();
        if (messageData.uid) {
          uniqueUsers.add(messageData.uid);
        }
      });
      
      return {
        id: forumDoc.id,
        name: forumData.name,
        createdAt: forumData.createdAt,
        messageCount: messagesSnapshot.size,
        userCount: uniqueUsers.size
      };
    }));

    // Sort forums by message count in descending order
    return forumsWithCounts.sort((a, b) => b.messageCount - a.messageCount);
  } catch (error) {
    console.error("Error fetching forums with message counts:", error);
    return [];
  }
};